import styled, { css } from 'styled-components'
import React, { PureComponent } from 'react'
import * as d3 from 'd3'
import { small, medium } from '../../lib/media_query'
import theme from '../../theme'

const Wrapper = styled.div`
    position: relative;

    ${small(css`
        transform: scale(0.6);
    `)};

    ${medium(css`
        transform: scale(0.8);
    `)};

    .face {
        z-index: 1;
        width: 250px;
        height: 250px;
        margin: 0 auto;
        position: relative;
        border: 12px solid #fff;
        border-radius: 50%;
        box-shadow: 0 2px 8px rgba(34, 34, 34, 0.3), inset 0px 13px rgba(34, 34, 34, 0.1);

        .handle {
            background-color: white;
            box-shadow: 0 2px 8px rgba(34, 34, 34, 0.3), inset 0px 2px rgba(34, 34, 34, 0.1);
            width: 26px;
            height: 200px;
            border-bottom-left-radius: 50px;
            border-bottom-right-radius: 50px;
            transform: rotate(-41deg);
            position: absolute;
            top: 192px;
            right: -55px;
        }
    }

    div.key {
        width: 44px;
        height: 44px;
        position: absolute;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), inset 0 -3px 0 rgba(0, 0, 0, 0.15);

        span {
            color: rgba(255, 255, 255, 0.9);
            font-size: 18px;
            font-weight: 600;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
    }
`
const keyAnimationDuration = d3.randomUniform(9000, 11000)
const keyLeftPos = d3.randomUniform(20, 160)
const keyColour = theme.palette.brand.blue
const magnifiedKeyColour = theme.palette.brand.green
const keyLetters = 'ABCDEFGHJKLMNPQRSTUVWXYZ'.split('')
const getRandomLetter = () => keyLetters[Math.floor(Math.random() * keyLetters.length)]

export default class extends PureComponent {
    populateInitialKeys() {
        for (let i = 0; i < 2; i++) {
            this.append(i * 100 - 180)
        }
    }

    componentDidMount() {
        this.populateInitialKeys()
        this.interval = setInterval(() => this.append(), 1200)
        this.handleVisibilityChange = () => {
            if (document.hidden) {
                clearInterval(this.interval)
                this.interval = null
            } else {
                if (!this.interval) {
                    this.interval = setInterval(() => this.append(), 1200)
                }
            }
        }
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    }

    append(top = -150) {
        var movementTransition = d3
            .transition()
            .duration(keyAnimationDuration())
            .ease(d3.easeLinear)

        const newKey = d3
            .select(this.keys)
            .append('div')
            .attr('class', 'key')
            .style('left', () => keyLeftPos() + 'px')
            .style('top', `${top}px`)
            .style('filter', 'opacity(0)')
            .html(`<span>${getRandomLetter()}</span>`)

        newKey
            .transition(movementTransition)
            .delay(Math.floor(Math.random() * 500))
            .style('top', `${400}px`)
            .style('transform', `rotate(${Math.random() * 360}deg)`)
            .on('end', function () {
                const key = d3.select(this)
                key.transition().on('end', () => key.remove())
            })
            .styleTween('background-color', function () {
                return d3
                    .scaleLinear()
                    .range([
                        keyColour,
                        keyColour,
                        magnifiedKeyColour,
                        magnifiedKeyColour,
                        keyColour
                    ])
                    .domain([0, 0.18, 0.32, 0.6, 0.7])
            })
            .styleTween('filter', function () {
                const scale = d3.scaleLinear().range([0, 0.8, 0.7, 0]).domain([0, 0.4, 0.5, 1])
                return (t) => `opacity(${scale(t)})`
            })
    }

    render() {
        return (
            <Wrapper>
                <div className="face">
                    <div className="handle" />
                </div>
                <div ref={(keys) => (this.keys = keys)} />
            </Wrapper>
        )
    }
}
